import { forwardRef, type Ref, type SVGProps } from "react";

function SvgQuizInverted(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={176}
      height={120}
      fill="none"
      {...props}
    >
      <rect
        width={76}
        height={94}
        x={50}
        y={13}
        stroke="url(#quiz_inverted_svg__a)"
        strokeWidth={8}
        rx={16}
      />
      <path stroke="#fff" strokeLinecap="round" d="M67 34.5h42m-42 10h42" />
      <path
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M96.5 83.25 100 87l8.167-10"
      />
      <defs>
        <linearGradient
          id="quiz_inverted_svg__a"
          x1={88}
          x2={87.5}
          y1={13}
          y2={84}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.195} stopColor="#BDDFFE" />
          <stop offset={1} stopColor="#F6F3F1" />
        </linearGradient>
      </defs>
    </svg>
  );
}
const ForwardRef = forwardRef(SvgQuizInverted);
export default ForwardRef;
